import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getBusinessReports, getReportsCCAndCountryLocal } from '../selector';

import { notify } from '../../../components/libs/notification';

import * as actions from '../actions';

import NewReport from './NewReport';

const mapStateToProps = state => {
  const { fetchingReports } = state.reports;
  const businessReports = getBusinessReports(state);

  const {
    reports,
    fields,
    selectedFields,
    reportName,
    reportDescription,
    fetchingReportFields,
    exportingCustomisedReport,
    savingReport,
    reportId,
    reportCategory,
    filters,
    schedule,
    recipients,
    businessReportId,
    deletingReport,
    isScheduleUpdated,
    username,
    businessReport,
    dynamicFilters
  } = state.reports;

  return {
    fetchingReports,
    businessReports,
    ...getReportsCCAndCountryLocal(state),
    reports,
    fields,
    selectedFields,
    reportCategory,
    reportId,
    reportName,
    reportDescription,
    fetchingReportFields,
    exportingCustomisedReport,
    savingReport,
    filters,
    schedule,
    recipients,
    businessReportId,
    deletingReport,
    username,
    isScheduleUpdated,
    businessReport,
    dynamicFilters
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  notify: bindActionCreators(notify, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, {
  withRef: true
})(NewReport);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/NewReportContainer.js